var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666016 9.00033C0.666016 4.40033 4.39933 0.666992 8.99935 0.666992C13.5994 0.666992 17.3327 4.40033 17.3327 9.00033C17.3327 13.6003 13.5994 17.3337 8.99935 17.3337C4.39933 17.3337 0.666016 13.6003 0.666016 9.00033ZM9.83268 12.7503C9.83268 12.9805 9.64612 13.167 9.41602 13.167H8.58268C8.35258 13.167 8.16602 12.9805 8.16602 12.7503V8.58366C8.16602 8.35353 8.35258 8.16699 8.58268 8.16699H9.41602C9.64612 8.16699 9.83268 8.35353 9.83268 8.58366V12.7503ZM8.99935 15.667C5.32432 15.667 2.33268 12.6753 2.33268 9.00033C2.33268 5.32532 5.32432 2.33366 8.99935 2.33366C12.6744 2.33366 15.666 5.32532 15.666 9.00033C15.666 12.6753 12.6744 15.667 8.99935 15.667ZM9.41602 6.50033H8.58268C8.35258 6.50033 8.16602 6.31379 8.16602 6.08366V5.25033C8.16602 5.0202 8.35258 4.83366 8.58268 4.83366H9.41602C9.64612 4.83366 9.83268 5.0202 9.83268 5.25033V6.08366C9.83268 6.31379 9.64612 6.50033 9.41602 6.50033Z",
    fill: "#697377"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.0fe08c52.svg";
export { ForwardRef as ReactComponent };